import type { App, Plugin } from 'vue';
import { type Router } from 'vue-router';
import Toast, { POSITION, useToast } from 'vue-toastification';

export const ToastPlugin = (router: Router, i18n: { install: (app: App) => void }): Plugin => ({
  install(app: App) {
    app.use(Toast, {
      // Enable use of router and i18n in custom toast components
      // https://github.com/Maronato/vue-toastification/issues/350#issuecomment-1946734530
      onMounted: (_: typeof Toast, toastApp: App) => {
        toastApp.use(router);
        toastApp.use(i18n);
      },
      position: POSITION.BOTTOM_CENTER,
      bodyClassName: ['p-toast-body'],
      hideProgressBar: true,
      icon: false,
      transition: 'Vue-Toastification__fade',
      transitionDuration: {
        enter: 500,
        leave: 250,
      },
    });

    app.config.globalProperties.$toast = useToast();
  },
});
